import { createFileRoute, redirect } from '@tanstack/react-router';
import { PROTECTED, WAREHOUSE } from '@/lib/constants/routes';
import { WAREHOUSE_FILTER_TAB_VALUES } from '@/pages/warehouse/shared/warehouse-filter-tabs';

export const Route = createFileRoute('/protected/_layout/inventory/_layout/')({
  beforeLoad: () => {
    throw redirect({
      to: `${PROTECTED}${WAREHOUSE}`,
      search: { subTab: WAREHOUSE_FILTER_TAB_VALUES.INVENTORY },
    });
  },
});
